import { render } from "./recap.vue?vue&type=template&id=531e6092&scoped=true"
import script from "./recap.vue?vue&type=script&lang=js"
export * from "./recap.vue?vue&type=script&lang=js"

import "./recap.vue?vue&type=style&index=0&id=531e6092&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-531e6092"]])

export default __exports__